export const dicinaryStatus = {
	available: 'Disponível',
	complete: 'Finalizada',
	assigned: 'Minhas tarefas',
	deleted: 'Excluída',
};

export function applyDicinary(dicinaryName: string, status: keyof typeof dicinaryStatus): string {
	const dicinary = {
		dicinaryStatus,
	};

	return dicinary[<keyof typeof dicinary>dicinaryName]?.[status] || '';
}
